// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__FQy3R","checked":"Checkbox_checked__kDY3q"};